import type { AppContext } from 'types/common'
import component from './VendorSearch.svelte'

export default function ({ stateRouter }: AppContext) {
	stateRouter.addState({
		name: 'app.vendor-search',
		route: 'vendor-search',
		template: {
			svelte: true,
			component,
		},
		async resolve(_stateRouterData, { keyword }) {
			return Promise.resolve({
				searchKeyword: keyword || '',
			})
		},
	})
}
